import type {
  HubExampleArtifact,
  HubSampleArtifact,
  HubTagArtifact,
} from '@robovision/hub'
import { JobBaseArtifactWithoutDefinition } from './JobBaseArtifact'


export enum JobTaggableArtifactType {
  Example = 'Example',
  Sample = 'Sample',
  Tag = 'Tag',
}

export interface JobTaggableArtifactParams extends JobBaseArtifactWithoutDefinition {
  datapoolId: string
  type: JobTaggableArtifactType
}

export class JobTaggableArtifact extends JobBaseArtifactWithoutDefinition {
  public datapoolId: string
  public type: JobTaggableArtifactType

  protected constructor (params: JobTaggableArtifactParams) {
    super(params)
    this.datapoolId = params.datapoolId
    this.type = params.type
  }

  public static fromDefinition (
    hubArtifact: HubExampleArtifact | HubSampleArtifact | HubTagArtifact,
    type: JobTaggableArtifactType,
  ) {
    return new JobTaggableArtifact({
      artifactId: hubArtifact.id,
      datapoolId: hubArtifact.datapoolId,
      description: hubArtifact.description,
      name: hubArtifact.name,
      type,
    })
  }
}
